@if (loader) {
  <div class="loader-overlay"></div>
}
@if (loader) {
  <div class="loader-overlay-spinner">
    <span id="loading"></span>
  </div>
}

@if (supportMode) {
  <div #supportFrame class="support-frame">
    <div class="support-title">
      <h2>{{'support_frame'|translate|ucFirst}}</h2>
      <button
        class="send-support-report {{(modalFormIndex !== 0 ? 'wb-button-small' : '')}} {{(buttonstyle==='squared'? 'wb-squared' : '')}}"
        (click)="sendReport()">
        {{'send_report' | translate | ucFirst}}
      </button>
    </div>
    <div class="address-input">
      <h3>{{'order_details'|translate|ucFirst}}</h3>
      <table class="support-table">
        @if (formGroup.controls.departureModel.value) {
          <tr>
            <td>{{'departure'|translate|ucFirst}}</td>
            <td>
              {{formGroup.controls.departureModel.value.internationalAlias}}
            </td>
          </tr>
        }
        @if (formGroup.controls.destinationModel.value) {
          <tr>
            <td>{{'destination'|translate|ucFirst}}</td>
            <td>
              {{formGroup.controls.destinationModel.value.internationalAlias}}
            </td>
          </tr>
        }
        @if (formGroup.controls.requestedDate.value) {
          <tr>
            <td>{{'requested_date'|translate|ucFirst}}</td>
            <td>
              {{formGroup.controls.requestedDate.value}}
            </td>
          </tr>
        }
        @if (formGroup.controls.passengerCount.value) {
          <tr>
            <td>{{'passengers'|translate|ucFirst}}</td>
            <td>
              {{formGroup.controls.passengerCount.value}}
            </td>
          </tr>
        }
        @if (formGroup.controls.luggage && formGroup.controls.luggage.value) {
          <tr>
            <td>{{'luggage'|translate|ucFirst}}</td>
            <td>
              {{formGroup.controls.luggage.value}}
            </td>
          </tr>
        }
        @if (formGroup.controls.flightNumber && formGroup.controls.flightNumber.value) {
          <tr>
            <td>{{'flightnumber'|translate|ucFirst}}</td>
            <td>
              {{formGroup.controls.flightNumber.value}}
            </td>
          </tr>
        }
      </table>
    </div>
    @if (supportCalculationData.length > 0) {
      <div #priceCalculation class="price-log">
        <h3>{{'price_calculations'|translate|ucFirst}}</h3>
        <table class="support-table">
          @if (supportCalculationData && supportCalculationData[0]) {
            <tr>
              <td>{{'metrics'|translate|ucFirst}}</td>
              <td colspan="3">
                {{(supportCalculationData[0].metrics.distance).toFixed(2)}}{{(state.companySettings.distanceFormat  === 'km'? 'km' : 'Mi')}} /
                {{Math.round(supportCalculationData[0].metrics.duration)}}min
              </td>
            </tr>
          }
          @if (supportCalculationData && supportCalculationData[0].specialRatesAll?.length) {
            @for (rate of supportCalculationData[0].specialRatesAll; track $index) {
              <tr>
                <td>{{'special_rate'|translate|ucFirst}}</td>
                <td colspan="3">
                  {{rate.ruleName}}
                  - {{(rate.prices > 0 ?  'price_increase' : 'price_decrease') | translate | ucFirst}} {{(rate.type === 'percentage' ? rate.prices+'%'  : '')}}
                  {{(rate.type === 'fixed' ? (rate.prices/100)  : '')  | currency:state.currency:'symbol':'1.2-2'}}
                  @if (!rate.applied) { ({{'special_rate_not_applied' | translate}}) }
                </td>
              </tr>
            }
          } @else if (supportCalculationData && supportCalculationData[0].specialRates) {
            <tr>
              <td>{{'special_rate'|translate|ucFirst}}</td>
              <td colspan="3">
                {{supportCalculationData[0].specialRates.ruleName}}
                - {{(supportCalculationData[0].specialRates.prices > 0 ?  'price_increase' : 'price_decrease') | translate | ucFirst}} {{(supportCalculationData[0].specialRates.type === 'percentage' ? supportCalculationData[0].specialRates.prices+'%'  : '')}}
                {{(supportCalculationData[0].specialRates.type === 'fixed' ? (supportCalculationData[0].specialRates.prices/100)  : '')  | currency:state.currency:'symbol':'1.2-2'}}
              </td>
            </tr>
          }
          <tr>
            <th>{{'product'|translate|ucFirst}}</th>
            <th>{{'matched_rule'|translate|ucFirst}}</th>
            <th>{{'type'|translate|ucFirst}}</th>
            <th>{{'values'|translate|ucFirst}}</th>
          </tr>
          @for (link of supportCalculationData; track link; let fi = $index) {
            <tr >
              <td>{{link.rule.productName}} / <strong>{{link.price.total / 100 | currency:state.currency:'symbol':'1.2-2'}}</strong></td>
              <td>{{link.rule.ruleName}}</td>
              <td>{{link.rule.type|translate|ucFirst}}</td>
              @if (link.rule.type === 'fixed') {
                <td>
                  {{'fixed'|translate|ucFirst}} - {{link.rule.prices.fixedPrice / 100 | currency:state.currency:'symbol':'1.2-2'}}<br>
                </td>
              }
              @if (link.rule.type === 'dynamic') {
                <td>
                  {{'start'|translate|ucFirst}} - {{link.rule.prices.dynamicStartPrice / 100 | currency:state.currency:'symbol':'1.2-2'}}<br>
                  {{'distance'|translate|ucFirst}} - {{link.rule.prices.dynamicDistancePrice / 100 | currency:state.currency:'symbol':'1.2-2'}}<br>
                  {{'minimumprice_short'|translate|ucFirst}} - {{link.rule.prices.dynamicMinimumPrice / 100 | currency:state.currency:'symbol':'1.2-2'}}<br>
                  {{'minute'|translate|ucFirst}} - {{link.rule.prices.dynamicMinutePrice / 100 | currency:state.currency:'symbol':'1.2-2'}}<br>
                </td>
              }
            </tr>
          }
        </table>
      </div>
    }
    @if (returnTripSupportData.length > 0) {
      <div #priceCalculationReturn class="price-log">
        <h3>{{'price_calculations_returntrip'|translate|ucFirst}}</h3>
        <table class="support-table">
          @if (returnTripSupportData && returnTripSupportData[0]) {
            <tr>
              <td>{{'metrics'|translate|ucFirst}}</td>
              <td colspan="3">
                {{(returnTripSupportData[0].metrics.distance).toFixed(2)}}{{(state.companySettings.distanceFormat  === 'km'? 'km' : 'Mi')}} /
                {{Math.round(returnTripSupportData[0].metrics.duration)}}min
              </td>
            </tr>
          }
          @if (returnTripSupportData && returnTripSupportData[0].specialRatesAll?.length) {
            @for (rate of returnTripSupportData[0].specialRatesAll; track $index) {
              <tr>
                <td>{{'special_rate'|translate|ucFirst}}</td>
                <td colspan="3">
                  {{rate.ruleName}}
                  - {{(rate.prices > 0 ?  'price_increase' : 'price_decrease') | translate | ucFirst}} {{(rate.type === 'percentage' ? rate.prices+'%'  : '')}}
                  {{(rate.type === 'fixed' ? (rate.prices/100)  : '')  | currency:state.currency:'symbol':'1.2-2'}}
                  @if (!rate.applied) { ({{'special_rate_not_applied' | translate}}) }
                </td>
              </tr>
            }
          } @else if (returnTripSupportData && returnTripSupportData[0].specialRates) {
            <tr>
              <td>{{'special_rate'|translate|ucFirst}}</td>
              <td colspan="3">
                {{returnTripSupportData[0].specialRates.ruleName}}
                - {{(returnTripSupportData[0].specialRates.prices > 0 ?  'price_increase' : 'price_decrease') | translate | ucFirst}} {{(returnTripSupportData[0].specialRates.type === 'percentage' ? returnTripSupportData[0].specialRates.prices+'%'  : '')}}
                {{(returnTripSupportData[0].specialRates.type === 'fixed' ? (returnTripSupportData[0].specialRates.prices/100)  : '')  | currency:state.currency:'symbol':'1.2-2'}}
              </td>
            </tr>
          }
          <tr>
            <th>{{'product'|translate|ucFirst}}</th>
            <th>{{'matched_rule'|translate|ucFirst}}</th>
            <th>{{'type'|translate|ucFirst}}</th>
            <th>{{'values'|translate|ucFirst}}</th>
          </tr>
          @for (link of returnTripSupportData; track link; let fi = $index) {
            <tr >
              <td>{{link.rule.productName}} / <strong>{{link.price.total / 100 | currency:state.currency:'symbol':'1.2-2'}}</strong></td>
              <td>{{link.rule.ruleName}}</td>
              <td>{{link.rule.type|translate|ucFirst}}</td>
              @if (link.rule.type === 'fixed') {
                <td>
                  {{'fixed'|translate|ucFirst}} - {{link.rule.prices.fixedPrice / 100 | currency:state.currency:'symbol':'1.2-2'}}<br>
                </td>
              }
              @if (link.rule.type === 'dynamic') {
                <td>
                  {{'start'|translate|ucFirst}} - {{link.rule.prices.dynamicStartPrice / 100 | currency:state.currency:'symbol':'1.2-2'}}<br>
                  {{'distance'|translate|ucFirst}} - {{link.rule.prices.dynamicDistancePrice / 100 | currency:state.currency:'symbol':'1.2-2'}}<br>
                  {{'minimumprice'|translate|ucFirst}} - {{link.rule.prices.dynamicMinimumPrice / 100 | currency:state.currency:'symbol':'1.2-2'}}<br>
                  {{'minute'|translate|ucFirst}} - {{link.rule.prices.dynamicMinutePrice / 100 | currency:state.currency:'symbol':'1.2-2'}}<br>
                </td>
              }
            </tr>
          }
        </table>
      </div>
    }
    <div #tagManager class="tagmanager-log">
      <h3>{{'tag_manager'|translate|ucFirst}}</h3>
      <ul>
        @for (link of analytics.localLayer; track link; let fi = $index) {
          <li >
            {{link.event}} {{(link.virtualPageURL ? ' - ' : '')}} {{link.virtualPageURL}}
          </li>
        }
      </ul>
    </div>
  </div>
}

@if (processingPayment) {
  <div class="wb-processing-payment">
    <div class="wb-order-text">
      <div class="wb-lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <h3>{{'processing_payment' | translate | ucFirst}}</h3>
      <p>{{'processing_payment_text' | translate | ucFirst}}</p>
    </div>
  </div>
}
@if ((!onlyShowLoader)) {
  <div [class]="(supportMode ? 'support-mode wb-main-pane' : 'wb-main-pane')">
    @if ((showlogo || showbreadcrumbs) && formStyle !== 'widget' &&
      form.config.parts[selectedFormIndex] &&
      !['completion','failed'].includes(form.config.parts[selectedFormIndex].type)) {
      <nav class="wb-top wb-formstyle-{{formStyle}}"
        [ngClass]="{'wb-has-logo': showlogo && form.config.logo}"
        >
        <div class="wb-contain">
          <!-- LOGO -->
          @if (showlogo && (form.config.logo)) {
            <div class="wb-logo wb-page-{{selectedFormIndex}}"
              >
              @if (form.config.logo) {
                <span class="helper"></span>
              }
              @if (form.config.logo) {
                <img
                  [src]="form.config.logo"
                  alt="logo">
              }
            </div>
          }
          @if (showlogo && !form.config.logo) {
            <h3
              class="wb-logo wb-logotext wb-page-{{selectedFormIndex}}">
              {{ form.name }}
            </h3>
          }
          <!-- RIGHT SIDE (title + steps) -->
          @if (showbreadcrumbs) {
            <div class="wb-steps-pane">
              <!-- active step title -->
              @if (steps[selectedFormIndex]?.sidebar?.title) {
                <h3 class="wb-formtitle"
                  >
                  {{ steps[selectedFormIndex].sidebar.title | translate | ucFirst }}
                </h3>
              }
              <div class="wb-steps" [style.--step-count]="steps.length">
                @for (part of steps; track part; let i = $index; let isLast = $last) {
                  <div class="wb-step-wrap"
                    [ngClass]="{'wb-active': i === selectedFormIndex, 'wb-last': isLast}">
                    <div class="wb-step-dot"></div>
                    <div class="wb-step-label">
                      {{ part.title | translate | ucFirst }}
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </nav>
    }
    @if (formGroup && formStyle !== 'widget') {
      <form [formGroup]="formGroup"
        class="wb-form-container wb-page-{{selectedFormIndex}} wb-formstyle-{{formStyle}} wb-navigation-style-{{(formConfig === 'widget'? formConfig : navigation)}}"
        autocomplete="off"
        [style.padding-bottom.px]="(formStyle === 'webbooker' && formNavigation ? (formNavigation.offsetHeight-25) : 0)"
        >
        <!-- First field is to throw off browsers from using autocomplete -->
        <input autocomplete="off" name="hidden" type="text" style="display:none;">
        <!-- RideBits-style trip-type selector (first step), inline form path. Additive: only renders
        when showServiceSelector is true (mobile-popup theme / preview); zero impact otherwise. -->
        @if (showServiceSelector) {
          <div class="wb-service-selector">
            <h3 class="wb-service-selector-title">{{ 'service_selector_title' | translate | ucFirst }}</h3>
            @for (service of serviceTypes; track service) {
              <button type="button" class="wb-service-option"
                (click)="selectService(service)">
                <span class="wb-service-icon"><app-svg-icon [icon]="service.icon"></app-svg-icon></span>
                <span class="wb-service-text">
                  <span class="wb-service-name">{{ service.name | translate | ucFirst }}</span>
                  <span class="wb-service-sub">{{ service.sub | translate | ucFirst }}</span>
                </span>
                <span class="wb-service-chevron"><app-svg-icon [icon]="'chevron-down'"></app-svg-icon></span>
              </button>
            }
          </div>
        }
        @if (!showServiceSelector) {
          <div class="wb-form-slider"
            [ngStyle]="{width: (form.config.parts.length) * 100 + '%', margin: '0 0 0 -'+selectedFormIndex * 100+'%'}">
            @for (part of formParts; track part; let i = $index) {
              <div class="wb-form-part {{part.type}}"
                id="page-{{i}}"
                >
                <div class="{{(part.type === 'summary' ? '' : 'wb-booking-order-pane')}} {{(!['products'].includes(part.type) ? 'wb-has-summary' : '')}}">
                  @if (selectedFormIndex === 0 && form.config.hourlyBookings && form.config.routeBookings) {
                    <div class="wb-tab-pane">
                      <label>
                        <input type="checkbox"
                          [checked]="activeTab === 'route'"
                          (change)="activateTab('route')">
                          {{ 'route_bookings' | translate | ucFirst }}
                        </label>
                        <label>
                          <input type="checkbox"
                            [checked]="activeTab === 'hourly'"
                            (change)="activateTab('hourly')">
                            {{ 'hourly_bookings' | translate | ucFirst }}
                          </label>
                        </div>
                      }
                      <div class="wb-fields wb-order-form-fields">
                        {{form?.values?.returnTrip}}
                        @if (!['summary','completed','failed'].includes(part.type) && !['summary','completed','failed'].includes(part.title) && (!['products'].includes(part.type) || !formGroup?.controls['returnTrip']?.value)) {
                          <h3 class="wb-page-title">
                            {{'form_input_'+part.title | translate | ucFirst}}
                          </h3>
                        }
                        @if (['products','completed','failed'].includes(part.type) && !['summary','completed','failed'].includes(part.title)  && formGroup?.controls['returnTrip']?.value) {
                          <h3 class="wb-page-title">
                            {{'return_trip_details_title' | translate | ucFirst}}
                          </h3>
                        }
                        @if (part.type === 'products' && i === selectedFormIndex) {
                          <app-product-selection
                            [index]="i"
                            [form]="form"
                            [minimumOrderTime]="this.form.config.minimumOrderTime"
                            [products]="products"
                            [quotationEnabled]="canRequestQuote()"
                            (selectionFinished)="navigate($event)"
                            (scrollUp)="scrollUp()"
                            (requestQuote)="openQuoteContact()"
                            class="wb-formstyle-{{formStyle}} {{(formGroup.controls.returnTrip.value ? 'wb-product-selection-active-return' : '')}}"
                          (openHelpModal)="toggleHelpModal($event)"></app-product-selection>
                        }
                        @if (part.type === 'summary' && i === selectedFormIndex) {
                          <app-summary
                            [index]="i"
                            class="wb-formstyle-{{formStyle}}"
                            [form]="form"
                            [formGroup]="formGroup"
                            [selectedIndex]="selectedFormIndex"
                            [totalVat]="Math.round(totalPrice * (vatPercentage / 100))"
                            [vatPercentage]="vatPercentage"
                            [hideVat]="this.form.config.hideVat"
                            [totalPrice]="totalPrice"
                            [singlePrice]="singlePrice"
                            [singleProducts]="singleProducts"
                            [returnProducts]="returnProducts"
                            [transactionCosts]="transactionCosts"
                            [formNavigation]="productSelectionCode"
                            (bookOrder)="bookOrder()"
                            (navigate)="navigate($event)"
                            (openHelpModal)="toggleHelpModal($event)"
                            [buttonstyle]="buttonstyle"
                            [activeTab]="activeTab"
                          [returnPrice]="returnPrice"></app-summary>
                        }
                        @if (i === selectedFormIndex && !['completed','failed'].includes(part.type)) {
                          <div class="wb-field-container">
                            @for (field of part.fieldsWithLayoutInfo; track field; let fi = $index) {
                              @if (formGroup &&
                                !['products','summary'].includes(part.type) &&
                                !field.hidden) {
                                <app-field-wrapper
                                  [minimumOrderTime]="form.config.minimumOrderTime"
                  [className]="'wb-field wb-' + field.type + ' ' + field.cssclass +
                    (field.halfIndex !== null && field.halfIndex % 2 === 0 ? ' wb-no-margin' : '') +
                    (field.thirdIndex !== null && field.thirdIndex % 3 === 0 ? ' wb-no-margin' : '')"
                                  [index]="fi"
                                  [field]="field"
                                  [hiddenFieldTitles]="(i == 2)"
                                  [formGroup]="formGroup"
                                  [part]="part"
                                  [mainConfig]="form.config"
                                  [activeTab]="activeTab"
                                  (checkWorkArea)="checkWorkAreas($event)"
                                  (openHelpModal)="toggleHelpModal($event)">
                                </app-field-wrapper>
                              }
                            }
                          </div>
                        }
                      </div>
                    </div>
                    @if (i === selectedFormIndex && ['completion'].includes(part.type)) {
                      <app-confirmation [status]="orderStatus" [navigation]="navigation" [formStyle]="formStyle" [parent]="this"
                      ></app-confirmation>
                    }
                    @if (!['completed','failed'].includes(part.type) && !['products'].includes(part.type)) {
                      <div class="wb-sidebar"
                        >
                        <div class="wb-sidebar-mobile">
                          @if (part.sidebar && part.sidebar.title) {
                            <h3>{{part.sidebar.title | translate | ucFirst}}</h3>
                          }
                          @if (part.sidebar && part.sidebar.text) {
                            <span [innerHTML]="part.sidebar.text | translate | html"></span>
                          }
                        </div>
                        @if (part.sidebar && part.sidebar.module && part.sidebar.module === 'summary') {
                          @if (formGroup && formParts && form) {
                            <app-sidebar-summary
                              #sidebarSummary
                              [parts]="formParts"
                              [formGroup]="formGroup"
                              [form]="form"
                            [selectedFormIndex]="selectedFormIndex"></app-sidebar-summary>
                          }
                          @if (this.form.config.showRouteMap &&
                            this.formGroup.controls.departureModel.value && i === selectedFormIndex) {
                            <app-preview-route-map #routeMap
                              [form]="form" [formGroup]="formGroup" [metrics]="metrics"
                              [buttonstyle]="buttonstyle"
                            ></app-preview-route-map>
                          }
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </form>
        }
        <ngx-smart-modal #helpModal class="help-modal-pane smart-alert-popup" identifier="helpModal{{instanceId}}" customClass="nsm-dialog-animation-ttb help-modal-{{helpData.type}}">
          <span (click)="helpModal.close()" class="wb-close"></span>
          <h3>
            <app-svg-icon [icon]="faInfoCircle"></app-svg-icon>
            {{helpData.helpTitleTag | translate | ucFirst}}
          </h3>
          <p [innerHTML]="helpData.helpTextTag | translate | ucFirst"></p>
        </ngx-smart-modal>
        <ngx-smart-modal #supportReportModal identifier="supportReportModal{{instanceId}}" class="support-report-modal smart-alert-popup">
          <h3 class="support-report-modal-title">
            <app-svg-icon [icon]="faInfoCircle"></app-svg-icon>
            {{helpData.helpTitleTag | translate | ucFirst}}
          </h3>
          <p [innerHTML]="helpData.helpTextTag | translate | ucFirst" id="supportMail"></p>
          <button
            class="send-support-report wb-button-small {{(buttonstyle==='squared'? 'wb-squared' : '')}}"
            (click)="copyAndClose('supportMail')">
            {{'copy_and_close' | translate | ucFirst}}
          </button> class="smart-alert-popup"
        </ngx-smart-modal>
        <ngx-smart-modal #serviceAreaModal identifier="serviceAreaModal{{instanceId}}" customClass="nsm-dialog-animation-ttb" class="service-area-modal smart-alert-popup" (onOpen)="serviceAreaMapFitBounds()">
          <span (click)="serviceAreaModal.close()" class="wb-close"></span>
          <h3>
            <app-svg-icon [icon]="faInfoCircle"></app-svg-icon>
            {{helpData.helpTitleTag | translate | ucFirst}}
          </h3>
          @if (helpData && this.myPolygon) {
            <p>
              @if (googleMapsLoaded) {
                <google-map #serviceAreaMap height="480px" width="480px" [options]="{disableDefaultUI:true}">
                  <map-polygon [paths]="this.serviceArea" [options]="this.myPolygon"></map-polygon>
                  <map-marker [options]="departureMarker" [position]="formGroup.controls.departureModel.value.gps"></map-marker>
                  <map-marker [options]="destinationMarker" [position]="formGroup.controls.destinationModel && this.formGroup.controls.destinationModel.value && this.formGroup.controls.destinationModel.value.gps"></map-marker>
                </google-map>
              }
            </p>
          }
        </ngx-smart-modal>
        <ngx-smart-modal #navigationErrorModal identifier="navigationErrorModal{{instanceId}}" customClass="navigation-error nsm-dialog-animation-ttb" class="smart-alert-popup">
          <span (click)="closeNavigationError()" class="wb-close"></span>
          <h3 class="navigate-error-title">
            <app-svg-icon [icon]="faExclamationTriangle" class="navigate-error-icon"></app-svg-icon>
            <div [innerHTML]="navigationError.title | translate | ucFirst"></div>
          </h3>
          <p class="navigate-error-text" [innerHTML]="navigationError.text | translate | ucFirst"></p>
        </ngx-smart-modal>
        <ngx-smart-modal #paymentModal_{{productSelectionCode}} identifier="paymentModal_{{productSelectionCode}}{{instanceId}}"
          customClass="nsm-dialog-animation-ttb"
          (onClose)="closeModal()" (onDismiss)="closeModal()">
          <iframe #paymentModalIframe class="stripe-iframe"></iframe>
          <h3 class="navigate-error-title">
            <span (click)="navigationErrorModal.close()" class="wb-close"></span>
          </h3>
        </ngx-smart-modal>
        <ngx-smart-modal #paymentPreauthModal identifier="paymentPreauthModal{{instanceId}}" class="smart-alert-popup"
          customClass="payment-preauth-model nsm-dialog-animation-ttb"
          (onDismiss)="paymentPreauthModal.close()">
          <h3 [innerHTML]="'preauth_in_taxi_payment_title' | translate | ucFirst"></h3>
          <div [innerHTML]="'preauth_in_taxi_payment_message' | translate | ucFirst"></div>
          <div class="wb-container" style="padding-top:10px;">
            <button
              class="wb-button-small {{(buttonstyle==='squared'? 'wb-squared' : '')}}" (click)="paymentPreauthModal.close()">
            </button>
            <button
              class="wb-button-small {{(buttonstyle==='squared'? 'wb-squared' : '')}}"
              (click)="createPayment(true);paymentPreauthModal.close();">
              {{'preauth_amount_button' | translate | ucFirst}}
            </button>
          </div>
        </ngx-smart-modal>
        <ngx-smart-modal #orderConfirm identifier="orderConfirm{{instanceId}}" class="smart-alert-popup"
          customClass="payment-preauth-model nsm-dialog-animation-ttb"
          (onDismiss)="orderConfirm.close()">
          <h3 [innerHTML]="'orderconfirm_title' | translate | ucFirst"></h3>
          <div [innerHTML]="'orderconfirm_message' | translate | ucFirst"></div>
          <div class="wb-container" style="padding-top:10px;">
            <button
              class="wb-button-small {{(buttonstyle==='squared'? 'wb-squared' : '')}}" (click)="orderConfirm.close()">
            </button>
            <button
              class="wb-button-small {{(buttonstyle==='squared'? 'wb-squared' : '')}}"
              (click)="processOrder();orderConfirm.close();">
              {{'confirm_booking' | translate | ucFirst}}
            </button>
          </div>
        </ngx-smart-modal>
        <ngx-smart-modal #priceUpdate identifier="priceUpdate{{instanceId}}" class="smart-alert-popup"
          customClass="payment-preauth-model nsm-dialog-animation-ttb"
          (onDismiss)="paymentPreauthModal.close()">
          <h3 [innerHTML]="'price_update_title' | translate | ucFirst"></h3>
          @if (!returnSurcharge) {
            <span [innerHTML]="'price_update_message_discount' | translate | ucFirst"></span>
          }
          @if (returnSurcharge) {
            <span [innerHTML]="'price_update_message_surcharge' | translate | ucFirst"></span>
          }
          @if (priceUpdateButton) {
            <span>
              {{(state.currencySymbol ? state.currencySymbol :
              'currency_symbol_'+priceUpdateButton.totalPrice.currency.toLowerCase() | translate | ucFirst)}}{{priceUpdateButton.totalPrice.total / 100 | number:'1.2-2'}}
            </span>
          }
          <div class="wb-container" style="padding-top:10px;">
            <button
              class="wb-button-small {{(buttonstyle==='squared'? 'wb-squared' : '')}}" (click)="priceUpdate.close()">
              {{'close' | translate | ucFirst}}
            </button>
            <button
              class="wb-button-small {{(buttonstyle==='squared'? 'wb-squared' : '')}}"
              (click)="selectProduct();priceUpdate.close();">
              {{'accept_price' | translate | ucFirst}}
            </button>
          </div>
        </ngx-smart-modal>
        <ngx-smart-modal #termsAndConditionsModal identifier="termsAndConditionsModal{{instanceId}}"
          customClass="payment-preauth-model nsm-dialog-animation-ttb"
          (onDismiss)="termsAndConditionsModal.close()">
          <div [innerHTML]="'accept_terms_message' | translate | ucFirst" class="text-container"></div>
          <div class="wb-container" style="padding-top:10px;">
            <button
              class="wb-button-small {{(buttonstyle==='squared'? 'wb-squared' : '')}}" (click)="termsAndConditionsModal.close()">
              {{'close' | translate | ucFirst}}
            </button>
            <button
              class="wb-button-small {{(buttonstyle==='squared'? 'wb-squared' : '')}}"
              (click)="acceptTermsAndBook();priceUpdate.close();">
              {{'accept_terms_and_book' | translate | ucFirst}}
            </button>
          </div>
        </ngx-smart-modal>
        <ngx-smart-modal #quoteRequestedModal identifier="quoteRequestedModal{{instanceId}}"
          customClass="payment-preauth-model wb-quote-confirmation nsm-dialog-animation-ttb"
          (onDismiss)="quoteRequestedModal.close()">
          <div [innerHTML]="'request_quote_confirmation_message' | translate | ucFirst" class="text-container"></div>
          <div class="wb-container" style="padding-top:10px;">
            <!-- Points at the dedicated quote/payment page (see quotePageUrl / environment.quotePageUrl);
            hidden until that page's real URL is set. -->
            @if (quotePageUrl) {
              <a [href]="quotePageUrl" target="_blank" rel="noopener"
                class="wb-button-small {{(buttonstyle==='squared'? 'wb-squared' : '')}}">
                {{'request_quote_go_to_quote_page' | translate | ucFirst}}
              </a>
            }
            <button
              class="wb-button-small {{(buttonstyle==='squared'? 'wb-squared' : '')}}" (click)="quoteRequestedModal.close()">
              {{'close' | translate | ucFirst}}
            </button>
          </div>
        </ngx-smart-modal>
        <!-- Product page: collect the page-3 contact details, then submit the quotation. -->
        <ngx-smart-modal #quoteContactModal identifier="quoteContactModal{{instanceId}}"
          customClass="payment-preauth-model nsm-dialog-animation-ttb"
          (onDismiss)="quoteContactModal.close()">
          <div [innerHTML]="'request_quote_contact_intro' | translate | ucFirst" class="text-container"></div>
          <div class="wb-field-container">
            @for (field of quoteContactFields; track field; let fi = $index) {
              <app-field-wrapper
                [className]="'wb-field wb-' + field.type"
                [index]="fi"
                [field]="field"
                [formGroup]="formGroup"
                [part]="quoteContactPart"
                [mainConfig]="form.config"
              (openHelpModal)="toggleHelpModal($event)"></app-field-wrapper>
            }
          </div>
          <div class="wb-container" style="padding-top:10px;">
            <button
              class="wb-button-small {{(buttonstyle==='squared'? 'wb-squared' : '')}}" (click)="quoteContactModal.close()">
              {{'close' | translate | ucFirst}}
            </button>
            <button
              class="wb-button-small {{(buttonstyle==='squared'? 'wb-squared' : '')}}"
              (click)="submitQuoteFromDialog(quoteContactModal)">
              {{'request_quote_submit' | translate | ucFirst}}
            </button>
          </div>
        </ngx-smart-modal>
        <!-- Summary page: confirm before sending the quotation. -->
        <ngx-smart-modal #quoteConfirmModal identifier="quoteConfirmModal{{instanceId}}"
          customClass="payment-preauth-model nsm-dialog-animation-ttb"
          (onDismiss)="quoteConfirmModal.close()">
          <div [innerHTML]="'request_quote_confirm_explain' | translate | ucFirst" class="text-container"></div>
          <div class="wb-container" style="padding-top:10px;">
            <button
              class="wb-button-small {{(buttonstyle==='squared'? 'wb-squared' : '')}}" (click)="quoteConfirmModal.close()">
              {{'close' | translate | ucFirst}}
            </button>
            <button
              class="wb-button-small {{(buttonstyle==='squared'? 'wb-squared' : '')}}"
              (click)="submitQuoteFromDialog(quoteConfirmModal)">
              {{'request_quote_submit' | translate | ucFirst}}
            </button>
          </div>
        </ngx-smart-modal>
        @if (formStyle !== 'widget' &&
          form.config.parts[selectedFormIndex]
          && !['completion','failed'].includes(form.config.parts[selectedFormIndex].type)) {
          <nav #formNavigation id="{{productSelectionCode}}_formNavigation"
            class="wb-form wb-page-{{selectedFormIndex}} wb-formstyle-{{formStyle}}"
            >
            <div class="wb-desktop wb-error-list {{isErroneous ? 'active' : ''}}">
              @for (error of globalErrors; track error) {
                <span>{{error.text | translate | ucFirst}}</span>
              }
            </div>
            <div class="wb-container{{(formGroup.controls.returnTrip.value ? ' retour-nav' : '')}}{{(canRequestQuote() && selectedFormIndex === (form.config.parts.length - 2) ? ' wb-nav-with-quote' : '')}}">
              @if (canShowNextButton()) {
                <button
                  class="wb-next {{(selectedFormIndex !== 0 ? 'wb-button-small' : '')}} {{(buttonstyle==='squared'? 'wb-squared' : '')}}"
                  (click)="navigate('next')">
                  {{(selectedFormIndex === 0 ? 'text_next_page_1_button' : 'text_next_button' ) | translate | ucFirst}}
                </button>
              }
              @if (selectedFormIndex === (form.config.parts.length - 2)) {
                <button
                  class="wb-next {{(selectedFormIndex !== 0 ? 'wb-button-small' : '')}} {{(buttonstyle==='squared'? 'wb-squared' : '')}}"
                  (click)="bookOrder()">
                  {{'process_order_button' | translate | ucFirst}}
                </button>
              }
              @if (canRequestQuote() && selectedFormIndex === (form.config.parts.length - 2)) {
                <button
                  class="wb-next wb-quote-summary {{(selectedFormIndex !== 0 ? 'wb-button-small' : '')}} {{(buttonstyle==='squared'? 'wb-squared' : '')}}"
                  (click)="openQuoteConfirm()">
                  {{'request_quote_button' | translate | ucFirst}}
                </button>
              }
              @if (selectedFormIndex !== 0) {
                <button
                  class="wb-previous {{(selectedFormIndex !== 0 ? 'wb-button-small' : '')}} {{(buttonstyle==='squared'? 'wb-squared' : '')}}"
                  (click)="navigate('back')">
                  {{'text_back_button' | translate | ucFirst}}
                </button>
              }
            </div>
            @if (supportLinkUrl) {
              <a class="wb-poweredBy wb-supportLink" [href]="supportLinkUrl" rel="noopener noreferrer"
              target="_blank">{{'support_link_text' | translate}}</a>
            }
            @if (showPoweredBy) {
              <a class="wb-poweredBy" [href]="poweredByHref" rel="noopener"
              target="_blank">{{'powered_by' | translate:{brand: poweredByBrandName} }}</a>
            }
          </nav>
        }
        @if (navigation === 'modal') {
          <ngx-smart-modal #productSelection_{{productSelectionCode}}{{instanceId}} identifier="productSelection_{{productSelectionCode}}{{instanceId}}"
            customClass="nsm-dialog-animation-ttb"
            (onClose)="closeModal()" (onDismiss)="closeModal()">
            @if (showclose) {
              <a class="wb-close" (click)="this.closeMyModal()"
              target="_new"></a>
            }
            <!-- RideBits-style trip-type selector (first step). Additive: only renders when
            showServiceSelector is true (mobile-popup theme / preview); zero impact otherwise. -->
            @if (showServiceSelector) {
              <div class="wb-service-selector">
                <h3 class="wb-service-selector-title">{{ 'service_selector_title' | translate | ucFirst }}</h3>
                @for (service of serviceTypes; track service) {
                  <button type="button" class="wb-service-option"
                    (click)="selectService(service)">
                    <span class="wb-service-icon"><app-svg-icon [icon]="service.icon"></app-svg-icon></span>
                    <span class="wb-service-text">
                      <span class="wb-service-name">{{ service.name | translate | ucFirst }}</span>
                      <span class="wb-service-sub">{{ service.sub | translate | ucFirst }}</span>
                    </span>
                    <span class="wb-service-chevron"><app-svg-icon [icon]="'chevron-down'"></app-svg-icon></span>
                  </button>
                }
              </div>
            }
            @if (!showServiceSelector && (showlogo || showbreadcrumbs) && form.config.parts[selectedFormIndex] &&
              (!['completion','failed'].includes(form.config.parts[selectedFormIndex].type) ||
              (widgettype === 'mobile-popup-widget' && form.config.parts[modalFormIndex]?.type === 'completion'))) {
              <nav class="wb-top wb-formstyle-{{formStyle}}"
                >
                <div class="wb-contain">
                  <!-- active step title above all steps (final page: show the confirmation title; the modal
                  tracks modalFormIndex, which is the completion part while selectedFormIndex lags). -->
                  @if (steps[modalFormIndex]?.sidebar?.title || form.config.parts[modalFormIndex]?.type === 'completion' || widgettype === 'mobile-popup-widget') {
                    <h3 class="wb-formtitle">
                      {{ (form.config.parts[modalFormIndex]?.type === 'completion'
                      ? ('order_confirmation_title_' + orderStatus)
                      : (steps[modalFormIndex]?.sidebar?.title
                      ? steps[modalFormIndex].sidebar.title
                      : ('form_input_' + $safeNavigationMigration(form.config.parts[modalFormIndex]?.title)))) | translate | ucFirst }}
                    </h3>
                  }
                  <div class="wb-steps" [style.--step-count]="steps.length">
                    @for (part of steps; track part; let i = $index; let isLast = $last) {
                      <!-- Active step follows modalFormIndex: the modal body is driven by modalFormIndex
                      (slider margin + all i===modalFormIndex checks), while selectedFormIndex lags for
                      the widget on steps without a before-fn (see navigate()), so binding the active
                      icon/title to selectedFormIndex left e.g. the "your details" icon inactive. -->
                      <div class="wb-step-wrap" [ngClass]="{'wb-active': i === modalFormIndex, 'wb-last': isLast}">
                        <div class="wb-step-dot"></div>
                        <div class="wb-step-label">{{ part.title | translate | ucFirst }}</div>
                      </div>
                    }
                  </div>
                </div>
              </nav>
            }
            @if (!showServiceSelector) {
              <form [formGroup]="formGroup" class="wb-form-container wb-page-{{modalFormIndex}} wb-formstyle-{{formStyle}}"
                autocomplete="off">
                <!-- First field is to throw off browsers from using autocomplete -->
                <input autocomplete="off" name="hidden" type="text" style="display:none;">
                <div class="wb-form-slider"
                  [ngStyle]="{width: (form.config.parts.length) * 100 + '%', margin: '0 0 0 -'+modalFormIndex * 100+'%'}">
                  @for (part of form.config.parts; track part; let i = $index) {
                    <div class="wb-form-part {{part.type}}"
                      id="page-{{i}}"
                      [ngStyle]="{width: 100 / form.config.parts.length + '%'}">
                      <div class="{{(part.type === 'summary' ? '' : 'wb-booking-order-pane')}}">
                        @if (selectedFormIndex === 0 && form.config.hourlyBookings && form.config.routeBookings) {
                          <div class="wb-tab-pane">
                            <label>
                              <input type="checkbox"
                                [checked]="activeTab === 'route'"
                                (change)="activateTab('route')">
                                {{ 'route_bookings' | translate | ucFirst }}
                              </label>
                              <label>
                                <input type="checkbox"
                                  [checked]="activeTab === 'hourly'"
                                  (change)="activateTab('hourly')">
                                  {{ 'hourly_bookings' | translate | ucFirst }}
                                </label>
                              </div>
                            }
                            @if (!['completion'].includes(part.type)) {
                              <div class="wb-fields">
                                @if (part.type === 'products' && i === modalFormIndex) {
                                  <app-product-selection
                                    [index]="i"
                                    [form]="form"
                                    [minimumOrderTime]="this.form.config.minimumOrderTime"
                                    [products]="products"
                                    [quotationEnabled]="canRequestQuote()"
                                    (selectionFinished)="navigate($event)"
                                    (scrollUp)="scrollUp()"
                                    (requestQuote)="openQuoteContact()"
                                  (openHelpModal)="toggleHelpModal($event)"></app-product-selection>
                                }
                                @if (part.type === 'summary' && i === modalFormIndex) {
                                  <app-summary
                                    [index]="i"
                                    [form]="form"
                                    [formGroup]="formGroup"
                                    [selectedIndex]="modalFormIndex"
                                    [totalVat]="Math.round(totalPrice * (vatPercentage / 100))"
                                    [vatPercentage]="vatPercentage"
                                    [hideVat]="this.form.config.hideVat"
                                    [totalPrice]="totalPrice"
                                    [singlePrice]="singlePrice"
                                    [singleProducts]="singleProducts"
                                    [returnProducts]="returnProducts"
                                    [transactionCosts]="transactionCosts"
                                    [formNavigation]="productSelectionCode"
                                    (bookOrder)="bookOrder()"
                                    (navigate)="navigate($event)"
                                    [buttonstyle]="buttonstyle"
                                    [activeTab]="activeTab"
                                  [returnPrice]="returnPrice"></app-summary>
                                }
                                @if (i === modalFormIndex) {
                                  <div class="wb-field-container">
                                    @for (field of part.fieldsWithLayoutInfo; track field; let fi = $index) {
                                      @if (formGroup && part.type !== 'products' && part.type !== 'summary' && !field.hidden) {
                                        <app-field-wrapper
                                          [minimumOrderTime]="this.form.config.minimumOrderTime"
                    [className]="'wb-field wb-' + field.type + ' ' + field.cssclass +
                    (field.halfIndex !== null && field.halfIndex % 2 === 0 ? ' wb-no-margin' : '') +
                    (field.thirdIndex !== null && field.thirdIndex % 3 === 0 ? ' wb-no-margin' : '')"
                                          [index]="fi" [field]="field"
                                          [formGroup]="formGroup"
                                          [activeTab]="activeTab"
                                          [hiddenFieldTitles]="(i == 2)"
                                          [part]="part"
                                          [mainConfig]="form.config"
                                          (openHelpModal)="toggleHelpModal($event)"
                                          (checkWorkArea)="checkWorkAreas($event)"
                                        ></app-field-wrapper>
                                      }
                                    }
                                  </div>
                                }
                              </div>
                            }
                          </div>
                          @if (i === selectedFormIndex && ['completion'].includes(part.type)) {
                            <app-confirmation [status]="orderStatus" [navigation]="navigation" [formStyle]="formStyle" [parent]="this"
                            ></app-confirmation>
                          }
                          @if (!['completion', 'products'].includes(part.type)) {
                            <div class="wb-sidebar">
                              @if (part.sidebar && part.sidebar.title) {
                                <h3>{{part.sidebar.title | translate | ucFirst}}</h3>
                              }
                              @if (part.sidebar && part.sidebar.text) {
                                <span [innerHTML]="part.sidebar.text | translate | html"></span>
                              }
                              @if (part.sidebar && part.sidebar.module && part.sidebar.module === 'summary') {
                                @if (formGroup && formParts && form) {
                                  <app-sidebar-summary
                                    [parts]="formParts"
                                    [formGroup]="formGroup"
                                    [form]="form"
                                  [selectedFormIndex]="modalFormIndex"></app-sidebar-summary>
                                }
                                @if (this.form.config.showRouteMap &&
                                  this.formGroup.controls.departureModel.value && i === modalFormIndex) {
                                  <app-preview-route-map #routeMap
                                    [form]="form" [formGroup]="formGroup" [metrics]="metrics"
                                    [buttonstyle]="buttonstyle"
                                  ></app-preview-route-map>
                                }
                              }
                            </div>
                          }
                          @if (i === modalFormIndex && ['completion'].includes(part.type)) {
                            <app-confirmation [status]="orderStatus" [navigation]="navigation" [formStyle]="formStyle" [parent]="this"
                            ></app-confirmation>
                          }
                        </div>
                      }
                    </div>
                  </form>
                }
                @if (!showServiceSelector && form.config.parts[modalFormIndex]
                  && !['completion','failed'].includes(form.config.parts[modalFormIndex].type)) {
                  <nav class="wb-widget-form wb-page-{{modalFormIndex}}" id="{{productSelectionCode}}_formNavigationModal"
                    >
                    <div class="wb-desktop wb-error-list {{isErroneous ? 'active' : ''}}">
                      @for (error of globalErrors; track error) {
                        <span>{{error.text | translate | ucFirst}}</span>
                      }
                    </div>
                    <div class="wb-container{{(this.formGroup.controls.returnTrip.value ? ' retour-nav' : '')}}">
                      @if (canShowNextButton('modal')) {
                        <button
                          class="wb-next {{(modalFormIndex !== 0 ? 'wb-button-small' : '')}} {{(buttonstyle==='squared'? 'wb-squared' : '')}}"
                          (click)="navigate('next')">
                          {{'text_next_button' | translate | ucFirst}}
                        </button>
                      }
                      @if (modalFormIndex === (form.config.parts.length - 2)) {
                        <button
                          class="wb-next {{(modalFormIndex !== 0 ? 'wb-button-small' : '')}} {{(buttonstyle==='squared'? 'wb-squared' : '')}}"
                          (click)="bookOrder()">
                          {{'process_order_button' | translate | ucFirst}}
                        </button>
                      }
                      @if (modalFormIndex !== 0) {
                        <button
                          class="wb-previous {{(modalFormIndex !== 0 ? 'wb-button-small' : '')}} {{(buttonstyle==='squared'? 'wb-squared' : '')}}"
                          (click)="navigate('back')">
                          {{'text_back_button' | translate | ucFirst}}
                        </button>
                      }
                      @if (supportLinkUrl) {
                        <a class="wb-poweredBy wb-supportLink" [href]="supportLinkUrl" rel="noopener noreferrer" target="_blank">{{'support_link_text' | translate}}</a>
                      }
                      @if (showPoweredBy) {
                        <a class="wb-poweredBy" [href]="poweredByHref" rel="noopener" target="_blank">{{'powered_by' | translate:{brand: poweredByBrandName} }}</a>
                      }
                    </div>
                  </nav>
                }
              </ngx-smart-modal>
            }
            @if (formStyle === 'widget' && (widgettype === 'mobile-popup-widget' || (widgettype === 'popup-widget' && !modalOpen))) {
              <div
                class="wb-popup-widget wb-{{this.buttonposition}}"
                style="background-color:{{this.buttonbgcolor}};color:{{this.buttontextcolor}}"
                (click)="navigate('next', 0)"
              >{{this.buttontext|translate|ucFirst}}</div>
            }
          </div>
        }
